function searchModal() {
    const showClass = 'js-search-modal--show';
    const searchModal = document.querySelector('[data-search-modal]');
    const searchModalTriggers = document.querySelectorAll('[data-search-modal-trigger]');
    const searchModalCloseButton = document.querySelector('[data-search-modal-close]');
    const searchModalInput = document.querySelector('[data-search-modal-input]');
    const hideSearchModal = () => {
        searchModal.classList.remove(showClass);
        document.removeEventListener('keyup', hideSearchModalOnEscapeKey);
    };
    const showSearchModal = e => {
        e.preventDefault();
        searchModal.classList.add(showClass);
        window.scrollTo(0, 0);
        document.addEventListener('keyup', hideSearchModalOnEscapeKey);
        if (searchModalInput) {
            searchModalInput.focus();
        }
    };
    const hideSearchModalOnEscapeKey = event => {
        if (event.key === 'Escape') {
            hideSearchModal();
        }
    };
    const init = () => {
        if (searchModal && searchModalTriggers) {
            searchModalTriggers.forEach(trigger => {
                trigger.addEventListener('focus', e => {
                    showSearchModal(e);
                });
                trigger.addEventListener('click', e => {
                    showSearchModal(e);
                });
            });
            if (searchModalCloseButton) {
                searchModalCloseButton.addEventListener('click', hideSearchModal);
            }
            // Focus search input after opacity animation completes
            searchModal.ontransitionend = e => {
                if (
                    searchModal.classList.contains(showClass) &&
                    searchModalInput &&
                    e.propertyName === 'opacity'
                ) {
                    searchModalInput.focus();
                }
            };
        }
    };
    return {
        init: init,
    };
}

export default searchModal;
